import type { FC } from "react";

import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import { cn } from "@/ui/lib";
import {
  CALLOUT_DEFAULTS,
  CALLOUT_TITLE_ROW_START_CLASS_MAP,
  type TCalloutTitleProps,
} from "./Callout.config";
import { getCalloutCopyColumnClass } from "./Callout.utils";

export const CalloutTitle: FC<TCalloutTitleProps> = (
  {
    title,
    asset,
    orientation = CALLOUT_DEFAULTS.orientation,
  },
) => (
  <div
    data-component="CalloutTitle"
    className={cn(
      getCalloutCopyColumnClass(asset),
      CALLOUT_TITLE_ROW_START_CLASS_MAP[orientation],
    )}
  >
    <TextSubtitle isResponsive={false} size={2}>
      { title }
    </TextSubtitle>
  </div>
);
